import { Grid, Typography } from '@mui/material';

function Header() {
  return (
    <Grid container>
      <Grid item xs={8}>
        <Typography variant="h4">Change Requests</Typography>
      </Grid>
    </Grid>
  );
}

export default Header;
